import { RequestState } from '../../../types'
import { DetailsSettingsState } from './store'

export const LOAD_ACCOUNT_DETAILS_REQUEST = 'LOAD_ACCOUNT_DETAILS_REQUEST'
export const LOAD_ACCOUNT_DETAILS_RECEIVED = 'LOAD_ACCOUNT_DETAILS_RECEIVED'
export const LOAD_ACCOUNT_DETAILS_ERROR = 'LOAD_ACCOUNT_DETAILS_ERROR'

export type DetailsSettingsAction = 
  | { type: typeof LOAD_ACCOUNT_DETAILS_REQUEST }
  | { type: typeof LOAD_ACCOUNT_DETAILS_RECEIVED, accountDetails: any }
  | { type: typeof LOAD_ACCOUNT_DETAILS_ERROR }

export function detailsSettingsReducer(state: DetailsSettingsState, action: DetailsSettingsAction) {
  switch (action.type) {
    case LOAD_ACCOUNT_DETAILS_REQUEST: {
      return {...state,
        requestState: RequestState.Loading
      }
    }

    case LOAD_ACCOUNT_DETAILS_RECEIVED: {
      return {...state,
        requestState: RequestState.Loaded,
        accountDetails: action.accountDetails
      }
    }

    case LOAD_ACCOUNT_DETAILS_ERROR: {
      return {...state,
        requestState: RequestState.Loading
      }
    }

    default: {
      return state
    }
  }
}